import { alpha, Skeleton } from "@mui/material";

interface SkeletonProps {
    height?: number;
    width?: number;
}

export const RectangularSkeleton: React.FC<SkeletonProps> = ({
    height = 'auto',
    width = 'auto'
}) => {
    return (
        <Skeleton
            animation="wave"
            variant="rounded"
            height={height}
            width={width}
            sx={(theme) => ({
                backgroundColor: alpha(theme.palette.grey[50], 0.2),
            })}
        />
    );
};